var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.expand),expression:"expand"}],staticClass:"alert",attrs:{"color":"red","transition":"scroll-y-transition","type":"error"}},[_vm._v("Sorry, there is no district at that location.")])
}
var staticRenderFns = []

export { render, staticRenderFns }